export const ENV = {
  qa1: {
    regions: {
      india: {
        api_url: "https://qa1.foundit.in",
        site_map: "rexmonster",
        domain: "foundit.in",
        host_domain: "qa1.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      gulf: {
        api_url: "https://qa1.founditgulf.com",
        site_map: "monstergulf",
        domain: "founditgulf.com",
        host_domain: "qa1.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      singapore: {
        api_url: "https://qa1.foundit.sg",
        site_map: "monstersingapore",
        domain: "foundit.sg",
        host_domain: "qa1.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      thailand: {
        api_url: "https://qa1.monster.co.th",
        site_map: "monsterthailand",
        domain: "monster.co.th",
        host_domain: "qa1.monster.co.th",
        media_url: "media.monster.co.th",
        region: "thailand",
        country_code: "TH",
        country_isd_code: "66",
        country_id: "206",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      philippines: {
        api_url: "https://qa1.foundit.com.ph",
        site_map: "monsterphilippines",
        domain: "foundit.com.ph",
        host_domain: "qa1.foundit.com.ph",
        media_url: "media.foundit.com.ph",
        region: "philippines",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      vietnam: {
        api_url: "https://qa1.monster.com.vn",
        site_map: "monstervietnam",
        domain: "monster.com.vn",
        host_domain: "qa1.monster.com.vn",
        media_url: "media.monster.com.vn",
        region: "vietnam",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      malaysia: {
        api_url: "https://qa1.foundit.my",
        site_map: "monstermalaysia",
        domain: "foundit.my",
        host_domain: "qa1.foundit.my",
        media_url: "media.foundit.my",
        region: "malaysia",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      indonesia: {
        api_url: "https://qa1.foundit.id",
        site_map: "monsterindonesia",
        domain: "foundit.id",
        host_domain: "qa1.foundit.id",
        media_url: "media.foundit.id",
        region: "indonesia",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      hongkong: {
        api_url: "https://qa1.foundit.hk",
        site_map: "monsterhongkong",
        domain: "foundit.hk",
        host_domain: "qa1.foundit.hk",
        media_url: "media.foundit.hk",
        region: "hongkong",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
    },
  },
  qa2: {
    regions: {
      india: {
        api_url: "https://qa2.foundit.in",
        site_map: "rexmonster",
        domain: "foundit.in",
        host_domain: "qa1.foundit.in",
        media_url: "qa2media.foundit.in",
        region: "india",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      gulf: {
        api_url: "https://qa2.founditgulf.com",
        site_map: "monstergulf",
        domain: "founditgulf.com",
        host_domain: "qa2.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      singapore: {
        api_url: "https://qa2.foundit.sg",
        site_map: "monstersingapore",
        domain: "foundit.sg",
        host_domain: "qa2.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      thailand: {
        api_url: "https://qa2.monster.co.th",
        site_map: "monsterthailand",
        domain: "monster.co.th",
        host_domain: "qa2.monster.co.th",
        region: "thailand",
        country_code: "TH",
        country_isd_code: "66",
        country_id: "206",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      philippines: {
        api_url: "https://qa2.foundit.com.ph",
        site_map: "monsterphilippines",
        domain: "foundit.com.ph",
        host_domain: "qa2.foundit.com.ph",
        region: "philippines",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      vietnam: {
        api_url: "https://qa2.monster.com.vn",
        site_map: "monstervietnam",
        domain: "monster.com.vn",
        host_domain: "qa2.monster.com.vn",
        region: "vietnam",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      malaysia: {
        api_url: "https://qa2.foundit.my",
        site_map: "monstermalaysia",
        domain: "foundit.my",
        host_domain: "qa2.foundit.my",
        region: "malaysia",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      indonesia: {
        api_url: "https://qa2.foundit.id",
        site_map: "monsterindonesia",
        domain: "foundit.id",
        host_domain: "qa2.foundit.id",
        region: "indonesia",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      hongkong: {
        api_url: "https://qa2.foundit.hk",
        site_map: "monsterhongkong",
        domain: "foundit.hk",
        host_domain: "qa2.foundit.hk",
        region: "hongkong",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
    },
  },
  rfs: {
    regions: {
      india: {
        api_url: "https://rfs.foundit.in",
        site_map: "rexmonster",
        domain: "foundit.in",
        host_domain: "rfs.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      gulf: {
        api_url: "https://rfs.founditgulf.com",
        site_map: "monstergulf",
        domain: "founditgulf.com",
        host_domain: "rfs.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      singapore: {
        api_url: "https://rfs.foundit.sg",
        site_map: "monstersingapore",
        domain: "foundit.sg",
        host_domain: "rfs.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      thailand: {
        api_url: "https://rfs.monster.co.th",
        site_map: "monsterthailand",
        domain: "monster.co.th",
        host_domain: "rfs.monster.co.th",
        region: "thailand",
        country_code: "TH",
        country_isd_code: "66",
        country_id: "206",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      philippines: {
        api_url: "https://rfs.foundit.com.ph",
        site_map: "monsterphilippines",
        domain: "foundit.com.ph",
        host_domain: "rfs.foundit.com.ph",
        region: "philippines",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      vietnam: {
        api_url: "https://rfs.monster.com.vn",
        site_map: "monstervietnam",
        domain: "monster.com.vn",
        host_domain: "rfs.monster.com.vn",
        region: "vietnam",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      malaysia: {
        api_url: "https://rfs.foundit.my",
        site_map: "monstermalaysia",
        domain: "foundit.my",
        host_domain: "rfs.foundit.my",
        region: "malaysia",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      indonesia: {
        api_url: "https://rfs.foundit.id",
        site_map: "monsterindonesia",
        domain: "foundit.id",
        host_domain: "rfs.foundit.id",
        region: "indonesia",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      hongkong: {
        api_url: "https://rfs.foundit.hk",
        site_map: "monsterhongkong",
        domain: "foundit.hk",
        host_domain: "rfs.foundit.hk",
        region: "hongkong",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
    },
  },
  prod: {
    regions: {
      india: {
        api_url: "https://www.foundit.in",
        site_map: "rexmonster",
        domain: "foundit.in",
        host_domain: "www.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      gulf: {
        api_url: "https://www.founditgulf.com",
        site_map: "monstergulf",
        domain: "founditgulf.com",
        host_domain: "www.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      singapore: {
        api_url: "https://www.foundit.sg",
        site_map: "monstersingapore",
        domain: "foundit.sg",
        host_domain: "www.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      thailand: {
        api_url: "https://www.monster.co.th",
        site_map: "monsterthailand",
        domain: "monster.co.th",
        host_domain: "www.monster.co.th",
        region: "thailand",
        country_code: "TH",
        country_isd_code: "66",
        country_id: "206",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      philippines: {
        api_url: "https://www.foundit.com.ph",
        site_map: "monsterphilippines",
        domain: "foundit.com.ph",
        host_domain: "www.foundit.com.ph",
        region: "philippines",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      vietnam: {
        api_url: "https://www.monster.com.vn",
        site_map: "monstervietnam",
        domain: "monster.com.vn",
        host_domain: "www.monster.com.vn",
        region: "vietnam",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      malaysia: {
        api_url: "https://www.foundit.my",
        site_map: "monstermalaysia",
        domain: "foundit.my",
        host_domain: "www.foundit.my",
        region: "malaysia",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      indonesia: {
        api_url: "https://www.foundit.id",
        site_map: "monsterindonesia",
        domain: "foundit.id",
        host_domain: "www.foundit.id",
        region: "indonesia",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
      hongkong: {
        api_url: "https://www.foundit.hk",
        site_map: "monsterhongkong",
        domain: "foundit.hk",
        host_domain: "www.foundit.hk",
        region: "hongkong",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh",
      },
    },
  },
  local: {
    regions: {
      india: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.foundit.in",
        site_map: "rexmonster",
        domain: "foundit.in",
        host_domain: "qa1.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      gulf: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.founditgulf.com",
        site_map: "monstergulf",
        domain: "founditgulf.com",
        host_domain: "qa1.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      singapore: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.foundit.sg",
        site_map: "monstersingapore",
        domain: "foundit.sg",
        host_domain: "qa1.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      thailand: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.monster.co.th",
        site_map: "monsterthailand",
        domain: "monster.co.th",
        host_domain: "qa1.monster.co.th",
        media_url: "media.monster.co.th",
        region: "thailand",
        country_code: "TH",
        country_isd_code: "66",
        country_id: "206",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      philippines: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.foundit.com.ph",
        site_map: "monsterphilippines",
        domain: "foundit.com.ph",
        host_domain: "qa1.foundit.com.ph",
        media_url: "media.foundit.com.ph",
        region: "philippines",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      vietnam: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.monster.com.vn",
        site_map: "monstervietnam",
        domain: "monster.com.vn",
        host_domain: "qa1.monster.com.vn",
        media_url: "media.monster.com.vn",
        region: "vietnam",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      malaysia: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.foundit.my",
        site_map: "monstermalaysia",
        domain: "foundit.my",
        host_domain: "qa1.foundit.my",
        media_url: "media.foundit.my",
        region: "malaysia",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      indonesia: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.foundit.id",
        site_map: "monsterindonesia",
        domain: "foundit.id",
        host_domain: "qa1.foundit.id",
        media_url: "media.foundit.id",
        region: "indonesia",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
      hongkong: {
        api_url: "http://localhost:3000",
        // api_url: "https://qa1.foundit.hk",
        site_map: "monsterhongkong",
        domain: "foundit.hk",
        host_domain: "qa1.foundit.hk",
        media_url: "media.foundit.hk",
        region: "hongkong",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        recaptcha_site_key: "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3",
      },
    },
  },
};

export const REGION = {
  "foundit.in": "india",
  "founditgulf.com": "gulf",
  "foundit.sg": "singapore",
  "monster.co.th": "thailand",
  "foundit.com.ph": "philippines",
  "monster.com.vn": "vietnam",
  "foundit.my": "malaysia",
  "foundit.id": "indonesia",
  "foundit.hk": "hongkong",
};
